import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import EmptyState from '@atlaskit/empty-state';

import { useIntl } from 'src/hooks/intl';

type Props = {
  imageUrl?: string;
  header: FormattedMessage.MessageDescriptor;
  desc: FormattedMessage.MessageDescriptor;
  primaryAction?: {
    href: string;
    msg: FormattedMessage.MessageDescriptor;
  };
  secondaryAction?: {
    href: string;
    msg: FormattedMessage.MessageDescriptor;
  };
};

// Uses Atlaskit's EmptyState component. Handles
// translations and conditionally rendering href Buttons
const EmptyResults = ({
  header,
  desc,
  primaryAction,
  secondaryAction,
  imageUrl = undefined,
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <EmptyState
      imageUrl={imageUrl}
      header={intl.formatMessage(header)}
      description={<FormattedMessage {...desc} />}
      primaryAction={
        primaryAction && (
          <CustomThemeButton href={primaryAction.href}>
            <FormattedMessage {...primaryAction.msg} />
          </CustomThemeButton>
        )
      }
      secondaryAction={
        secondaryAction && (
          <CustomThemeButton href={secondaryAction.href}>
            <FormattedMessage {...secondaryAction.msg} />
          </CustomThemeButton>
        )
      }
    />
  );
};

export default EmptyResults;
